<template>
  <v-container class="view">
    <v-row justify="center" align="center" style="min-height:50vh">
      <v-col cols="12" sm="4">
        <h2 class="text-capitalize mb-1 display-5 mt-3">
          Provide your email
        </h2>
        <p class="pb-3 text--secondary sub-hero-text">
          An OTP would be sent to your inbox if provided email exist on our
          server.
        </p>
        <v-spacer></v-spacer>
        <!------------if error in account reset----------->
        <small v-if="resetError" class="red--text lighten-3 px-2 text-small text-center" v-text="errorMessage"></small>
        <v-spacer></v-spacer>
        <v-form v-model="valid" @submit.prevent="submit" lazy-validation ref="form">
          <v-text-field v-model="email" :rules="emailValidationRules" label="E-mail" required outlined
            placeholder="example@mailer.com"></v-text-field>

          <v-btn block type="submit" large class="white--text" color="var(--purple)" :loading="loading"
            :disabled="loading">
            Proceed
          </v-btn>

          <small class="grey-text">
            Back to <router-link to="login">Login</router-link></small>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import store from "@/store"
export default {
  data: () => ({
    valid: false,
    email: "",
    resetError: "",
    message: "",
    error: "",
    response: null,
    showError: false,
    loading: false,
    emailValidationRules: [
      (v) => !!v || "Please provide your registered email",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
  }),

  methods: {
    async submit() {
      try {
        const { email } = this;
        if (!this.$refs.form.validate()) {
          return
        }
        // destructure the response
        const { data: response } = await axios.post("/auth/forgotten-password", { email });
        const { data: { accessToken: token } } = response;
        //commit the access token to store and exit the function{
        store.dispatch("auth/set_otp_access_token", token)
        this.$router.push({ name: "confirm-reset-otp" });
        return
      }
      catch (error) {
        //inform the user of the error message 
        this.loading = false;
        this.resetError = true;
        this.errorMessage = error.response.data.message;
        // this.response = error.response.data;
        return
      }
    },
  },
};
</script>

<style scoped>
</style>